import { useLayoutEffect, useEffect } from "react";
import { isServer } from "@commercekit/shared";

export const useIsoMorphicEffect = isServer ? useEffect : useLayoutEffect;
